import React, { useEffect, useState } from "react";
import { ServiceStatus } from "./services/types/gallus";
import { useGetStatusQuery } from "./services/gallusTools";

type Props = {
  status: "operational" | "degraded" | "down";
};

const StatusBadge: React.FC<Props> = ({ status }) => {
  const label = {
    operational: "Operational",
    degraded: "Degraded",
    down: "Down",
  }[status];

  return <span className={`badge ${status}`}>{label}</span>;
};

export const Status: React.FC = () => {
  const [services, setServices] = useState<ServiceStatus[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const getStatus = useGetStatusQuery();

  useEffect(() => {
    if (getStatus.isSuccess && getStatus.status === "fulfilled") {
      try {
        setServices(getStatus.data);
      } catch {
        setError("Error retrieving status, please try again later.");
      }
      setLoading(false);
    }
  }, [getStatus]);

  return (
    <div className="status-page">
      <h1>System Status</h1>
      {loading && <p>Loading status, please wait.</p>}
      {loading && error && <p>{error}</p>}
      {!loading && !error && (
        <table className="status-table">
          <thead>
            <tr>
              <th>Component</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {services.map((svc) => (
              <tr key={svc.name}>
                <td>{svc.displayName}</td>
                <td>
                  <StatusBadge status={svc.status} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
